import { render, staticRenderFns } from "./PlayerVipLimits.vue?vue&type=template&id=240121ad&"
import script from "./PlayerVipLimits.vue?vue&type=script&lang=js&"
export * from "./PlayerVipLimits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports